import React, { memo } from "react";

const WayfinderArrivalModal = memo(
  ({ hasArrived, bibData, handleArrivalDone }) => {
    if (!hasArrived) return null;

    return (
      <div className="arrival-overlay">
        <div className="arrival-modal">
          <div className="arrival-header">
            <div className="arrival-icon">
              <i className="fas fa-stopwatch"></i>
            </div>
            <h2 className="arrival-title">Arrival & Start Time Reminder</h2>
          </div>

          <div className="arrival-content">
            <div className="arrival-timing">
              <p className="arrival-time">
                Please arrive by <strong>{bibData["ARRIVAL Time"]}</strong>.
              </p>
              <p className="start-time">
                Your Start Chute Time is at{" "}
                <strong>{bibData["ENTRY CHUTE TIME"]}</strong>.
              </p>
              <p className="arrival-message">Be ready and on time!</p>
            </div>
          </div>

          <button className="arrival-done-button" onClick={handleArrivalDone}>
            <i className="fas fa-check"></i>
            DONE
          </button>
        </div>
      </div>
    );
  }
);

WayfinderArrivalModal.displayName = "WayfinderArrivalModal";

export default WayfinderArrivalModal;
